import { useCurrentAccountContext } from '../../../../utils/current-account/CurrentAccountContext'
import { useICPlatformContext } from '../../../../utils/ic-platform/icPlatform.context'
import { type BadgeableEntry, type NavBadge } from './navBadge.types'
import { resolveNavBadges } from './navBadgeRules'

/**
 * Resolves the internal-only badges for a nav entry. Reads whether the user is
 * an Instacart employee and their effective platform version, then runs the
 * badge rule registry. Returns [] for external users (fast path).
 */
export const useNavBadges = (entry: BadgeableEntry): NavBadge[] => {
  const accountContext = useCurrentAccountContext()
  const { version } = useICPlatformContext()
  const isInternal = Boolean(accountContext?.account?.isInternal)

  return resolveNavBadges(entry, { isInternal, currentVersion: version })
}
